<div *ngIf="loading" [@fadeInOut]
     style="position: absolute; background: rgba(255, 255, 255, 1); top: 0; left: 0; height: 100%; width: 100%; z-index: 50; text-align: center;">
  <sb-icon class="spinner" icon="loadingBlockAnimation" [animationOptions]="{autoplay: true, loop:true}"
           [style.color]="'#004F90'"></sb-icon>
</div>
<div class="row" style="min-height: 280px;">
  <div class="col">
    <div class="row">
      <div class="col">
        <div class="inline-block w30px deviceOptionsHeader">
          <sb-icon class="danger" icon="setting"></sb-icon>&nbsp;
        </div>
        <div class="danger inline-block deviceOptionsHeader">
          &nbsp;{{'lang.devices.serviceRequest' | translate}}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tablewrap">
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100 tc" [innerHTML]="getServiceText()">
              </p>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100 tc">
                <button class="btn btn-danger" (click)="checkServiceDone()">
                  <sb-icon icon="success"></sb-icon>&nbsp;{{'lang.devices.serviceDone' | translate}}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
